/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PutPasswordAssignmentDataParser = 
/* #__PURE__ */ parsers.object([['password', codecString]]);
export class PutPasswordAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutPasswordAssignmentDataParser.decode(input).map(res => new PutPasswordAssignmentData(res));
    }
    static unsafeDecode(input) {
        return PutPasswordAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutPasswordAssignmentDataParser.encode(data);
    }
    static schema() {
        return PutPasswordAssignmentDataParser.schema();
    }
}
